import { t } from 'i18next'
import { ToastsErrorBottomLeft, ToastsErrorTopCenter } from './toastService'

const showResponseError = (error: any, toastPosition = 'Bottom-Left') => {
  const responseError = error.response

  const errors = []

  if (responseError.data.status === 401) {
    errors.push(t('loginErrorMessage'))
  } else if (responseError.data.status === 403) {
    errors.push(t('authorizationErrorMessage'))
  } else if (responseError.status === 400 && responseError?.data?.error_description) {
    errors.push(responseError.data.error_description)
  } else if (responseError.status === 400 && responseError.data) {
    errors.push(responseError.data[0])
  } else if (responseError.status === 500) {
    errors.push(responseError?.data?.Detail || responseError?.data?.Title)
  } else {
    errors.push(t('operationErrorMessage'))
  }
  toastPosition === 'TOP' ? ToastsErrorTopCenter(errors) : ToastsErrorBottomLeft(errors)
}

export default showResponseError
